<template lang="pug">
modal-window.modal-student-edit(:title='title', ref='modalWindow')
  .modal-student-edit__inner(v-if='studentEditData')
    .modal-student-edit__inner__body(ref='modalBody')
      .modal-student-edit__inner__body__error
        .modal-student-edit__inner__body__error__message.text-small(v-for='message in errorMessages') {{ message }}
      .modal-student-edit__inner__body__item(v-if='isAdmin')
        .modal-student-edit__inner__body__item__label.text-small(v-if='isUpdate')
          slot(name='academyNameDisabledLabel')
        .modal-student-edit__inner__body__item__label.text-small(v-else)
          slot(name='academyNameLabel')
        pulldown-select.modal-student-edit__inner__body__item__select(
          v-model='studentEditData.academyId',
          :selectOptions='academySelectOptions',
          :disabled='disableChangeAcademyBranch',
          @input='academyChangeEvent'
        )
      .modal-student-edit__inner__body__item(v-if='isAdminOrAcademy')
        .modal-student-edit__inner__body__item__label.text-small(v-if='isUpdate')
          slot(name='branchNameDisabledLabel')
        .modal-student-edit__inner__body__item__label.text-small(v-else)
          slot(name='branchNameLabel')
        pulldown-select.modal-student-edit__inner__body__item__select(
          v-model='studentEditData.branchId',
          :selectOptions='branchSelectOptions',
          :disabled='disableChangeAcademyBranch'
        )
      .modal-student-edit__inner__body__item
        .modal-student-edit__inner__body__item__label.text-small
          slot(name='gradeNameLabel')
        pulldown-select.modal-student-edit__inner__body__item__select(
          v-model='studentEditData.gradeId',
          :selectOptions='gradeSelectOptions',
          :disabled='disableInput'
        )
      .modal-student-edit__inner__body__item
        .modal-student-edit__inner__body__item__label.text-small
          slot(name='userNameLabel')
        textbox-setting.modal-student-edit__inner__body__item__input(
          v-model='studentEditData.userName',
          :placeholder='userNamePlaceholder',
          :disabled='disableInput'
        )
      .modal-student-edit__inner__body__item
        .modal-student-edit__inner__body__item__label.text-small
          slot(name='userBcbtCodeLabel')
        textbox-setting.modal-student-edit__inner__body__item__input(
          v-model='studentEditData.bcbtCode',
          :placeholder='userBcbtCodePlaceholder',
          :disabled='disableChangeAcademyBranch'
        )
      .modal-student-edit__inner__body__item
        .modal-student-edit__inner__body__item__label.text-small
          .modal-student-edit__inner__body__item__label__value
            slot(name='passwordLabel')
          .modal-student-edit__inner__body__item__label__annotation
            slot(name='passwordLabelAnnotation')
        textbox-setting.modal-student-edit__inner__body__item__input(
          type='password',
          v-model='studentEditData.password',
          :placeholder='passwordPlaceholder'
        )
      .modal-student-edit__inner__body__item
        .modal-student-edit__inner__body__item__label.text-small
          .modal-student-edit__inner__body__item__label__value
            slot(name='passwordConfirmLabel')
          .modal-student-edit__inner__body__item__label__annotation
            slot(name='passwordConfirmLabelAnnotation')
        textbox-setting.modal-student-edit__inner__body__item__input(
          type='password',
          v-model='studentEditData.passwordConfirm',
          :placeholder='passwordConfirmPlaceholder'
        )
      .modal-student-edit__inner__body__item
        .modal-student-edit__inner__body__item__label.text-small
          slot(name='statusLabel')
        textbox-setting.modal-student-edit__inner__body__item__input(
          v-model='studentEditData.status',
          :placeholder='statusPlaceholder',
          :disabled='disableInput'
        )
    .modal-student-edit__inner__footer
      button-modal-keep.modal-student-edit__inner__footer__button(@click='keep')
        slot(name='keepText')
</template>

<script lang="ts">
import { Component, Prop, Vue, Ref } from 'vue-property-decorator'
import ModalWindow from '@/components/molecules/manager/ModalWindow.vue'
import PulldownSelect from '@/components/molecules/manager/PulldownSelect.vue'
import TextboxSetting from '@/components/molecules/manager/TextboxSetting.vue'
import ButtonModalKeep from '@/components/molecules/manager/ButtonModalKeep.vue'
import { StudentEditType } from '@/models/studentListModel'
import { UserRoles } from '@/const/UserRoles'
import { InputItem } from '@/models/inputItem'

/**
 * ユーザー管理・生徒登録編集モーダル
 */
@Component({
  components: {
    ModalWindow,
    PulldownSelect,
    TextboxSetting,
    ButtonModalKeep,
  },
})
export default class ModalStudentEdit extends Vue {
  // ユーザ権限
  @Prop()
  userRole!: UserRoles

  // モーダルのタイトル
  @Prop()
  title!: string

  // 編集対象のユーザー（生徒）情報
  @Prop()
  studentEditData!: StudentEditType

  // 塾名選択プルダウンのオプション（システム管理者画面のみ）
  @Prop()
  academySelectOptions?: InputItem[]

  // 塾名変更時イベント（システム管理者のみ）
  @Prop()
  academyChangeEvent?: Function

  // 教室名選択プルダウンのオプション（システム管理者、塾管理者画面のみ）
  @Prop()
  branchSelectOptions?: InputItem[]

  // 学年名選択プルダウンのオプション
  @Prop()
  gradeSelectOptions!: InputItem[]

  // 氏名プレースホルダー
  @Prop()
  userNamePlaceholder!: string

  // BCBTコードプレースホルダー
  @Prop()
  userBcbtCodePlaceholder!: string

  // パスワードプレースホルダー
  @Prop()
  passwordPlaceholder!: string

  // パスワード（確認）プレースホルダー
  @Prop()
  passwordConfirmPlaceholder!: string

  // ステータスプレースホルダー
  @Prop()
  statusPlaceholder!: string

  // 保存ボタン押下時イベント
  @Prop()
  keepButtonEvent!: Function

  // エラーメッセージ
  @Prop()
  errorMessages!: string[]

  // モーダルウィンドウのRef
  @Ref()
  modalWindow!: ModalWindow

  // 入力エリア部のHTLMエレメント
  @Ref()
  modalBody!: HTMLElement

  // 保存処理
  private async keep() {
    await this.keepButtonEvent()
    if (this.errorMessages.length > 0) {
      // エラーメッセージがある場合は入力エリア部のトップまでスクロール
      this.modalBody.scrollTo({ top: 0 })
    } else {
      this.modalWindow.hide()
    }
  }

  public show() {
    this.modalWindow.show()
  }

  // システム管理者であるか
  private get isAdmin(): boolean {
    return this.userRole === UserRoles.ADMIN
  }

  // システム管理者または塾管理者であるか
  private get isAdminOrAcademy(): boolean {
    return this.userRoleIsAdminOrAcademy(this.userRole)
  }

  // 更新処理であるか
  private get isUpdate(): boolean {
    return !!this.studentEditData?.id
  }

  // 塾/教室変更不可フラグ
  private get disableChangeAcademyBranch(): boolean {
    // システム管理者以外、または更新処理の場合、変更不可
    return !this.isAdmin || this.isUpdate
  }

  // 入力不可フラグ
  private get disableInput(): boolean {
    // システム管理者以外は入力不可
    return !this.isAdmin
  }

  private userRoleIsAdminOrAcademy(role: UserRoles | string) {
    return role === UserRoles.ADMIN || role === UserRoles.ACADEMY
  }
}
</script>

<style lang="stylus" scoped>
.modal-student-edit
  &__inner
    display flex
    height 463px
    flex-direction column
    align-items flex-start
    gap 20px

    &__body
      display flex
      flex-direction column
      gap 12px
      overflow-y auto

      &__error
        &__message
          color var(--color-manager-modal-alert__text)

      &__item
        width 100%
        display flex
        flex-direction column
        gap 12px

        &__select
          width 100%

        &__label
          display flex
          justify-content space-between

    &__footer
      margin-top auto
</style>
